import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_MIRROR_HOSPITAL_RCPA_SELECT,
  RQ_GET_MIRROR_RCPA_SELECT,
  RQ_GET_RCPA_REPORTS_API,
} from '@app/reactQuery/apis/constants';

export const RQUseRCPAReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_rcpa_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, entityTagId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_RCPA_REPORTS_API,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
          entityTagId: entityTagId,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseMirrorRCPAReport = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_mirror_rcpa_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MIRROR_RCPA_SELECT,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromDate: startDate,
          toDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseMirrorHospitalRCPAReport = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_mirror_hospital_rcpa_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MIRROR_HOSPITAL_RCPA_SELECT,
        null,
        certificate,
        {
          divisionId: divisionId,
          fromDate: startDate,
          toDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};
